export class MathsNaiveStatic {

    public windowSize: number = 720;
    public noteMAX: number = 5;
    public coefLT: number = 50;
    public coefCT: number = 50;
    public coefVF: number = 5;
    public refLT: number = 0.01;
    public refCT: number = 0.01
}
